export const CHECKOUT = 'CHECKOUT'
export const CHECKOUT_SUCCESS = 'CHECKOUT_SUCCESS'
export const CHECKOUT_ERROR = 'CHECKOUT_ERROR'
export const ADD_CUSTOMER = 'ADD_CUSTOMER'
export const ADD_CUSTOMER_SUCCESS = 'ADD_CUSTOMER_SUCCESS'
export const PAYLATER_ORDER = 'PAYLATER_ORDER'
export const CHARGE_PAYMENT = 'CHARGE_PAYMENT'
export const CALCULATE_TAX = 'CALCULATE_TAX'